import { BaseResponse } from './internal/baseresponse';
export class NoticeModifyResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/noticemodifyresult.ts